import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"overflow":"auto","height":"100%","display":"flex","flex-direction":"column"} }
const _hoisted_2 = { style: {"position":"absolute","margin-bottom":"2px"} }
const _hoisted_3 = { style: {"position":"absolute","margin-bottom":"2px"} }
const _hoisted_4 = { style: {"margin-top":"2px"} }

import { IonItemSliding, IonItemOption, IonItemOptions, IonThumbnail, IonImg, IonList, IonIcon, IonItem, useIonRouter } from '@ionic/vue';
import { Storage } from '@ionic/storage';
import { ProcessResult } from 'plate-vision-demo-openapi-client/dist';
import { trash }  from 'ionicons/icons';
import { onMounted, ref} from 'vue';
import ReturnButton from '@/components/returnButton.vue';
import { useI18n } from 'vue-i18n';

interface FinalReport{
    response: ProcessResult,
    date: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportsList',
  setup(__props) {

const { t } = useI18n({
      inheritLocale: true,
      useScope: 'global'
})


const storage = new Storage();
const router = useIonRouter();
let reportHistory: FinalReport[] = [];
const deletedReports = ref<string[]>([]);
const load = ref<boolean>(false);


onMounted(() => {
    storage.create().then(() => {
        storage.get('reports').then((reportArray) => {
            if(reportArray){
                reportHistory = reportArray;
            }
            load.value = true;
        });
    });
})



function displayReport(reportIndex: number){
    router.push({
        name: 'report',
        params: { 
            index: reportIndex
        }
    }); 
}


function deleteReport(reportId: string, reportIndex: number){
    reportHistory.splice(reportIndex, 1);
    deletedReports.value?.push(reportId);
    storage.create().then(() => {
        storage.set('reports', reportHistory);
    })
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(IonList), {
        class: "bradius12 margin-1-rem-tb",
        style: {"overflow":"auto"}
      }, {
        default: _withCtx(() => [
          (_unref(reportHistory).length == 0 && load.value==true)
            ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('reportList.p1')), 1)
                ]),
                _: 1
              }))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(reportHistory), (report) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: report }, [
                  (!deletedReports.value.includes(report.response.responseUuid))
                    ? (_openBlock(), _createBlock(_unref(IonItemSliding), { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonItem), {
                            onClick: ($event: any) => (displayReport(_unref(reportHistory).indexOf(report)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonThumbnail), { style: {"height":"5rem","width":"5rem"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonImg), {
                                    src: 'data:'+report.response.processedImageMimeType+';base64,'+report.response.processedImage
                                  }, null, 8, ["src"])
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", null, [
                                (report.response.results.length > 1)
                                  ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", _hoisted_2, _toDisplayString(report.response.results[0].plate?.plateExtendedText) + " (" + _toDisplayString(_unref(t)('and')) + " " + _toDisplayString(report.response.results.length-1) + " " + _toDisplayString(_unref(t)('more')) + ") ", 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_unref(IonItem), { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", _hoisted_3, _toDisplayString(report.response.results[0] ? report.response.results[0].plate?.plateExtendedText : 'N/A'), 1)
                                      ]),
                                      _: 2
                                    }, 1024)),
                                _createVNode(_unref(IonItem), { lines: "none" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", _hoisted_4, _toDisplayString(report.date), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_unref(IonItemOptions), { side: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonItemOption), {
                                color: "danger",
                                style: {"border-radius":"8px","width":"6rem"},
                                onClick: ($event: any) => (deleteReport(report.response.responseUuid, _unref(reportHistory).indexOf(report)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    slot: "icon-only",
                                    icon: _unref(trash),
                                    size: "large"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(ReturnButton)
    ])
  ], 64))
}
}

})